import { render, staticRenderFns } from "./addCertSt.vue?vue&type=template&id=4f8ca364&scoped=true"
import script from "./addCertSt.vue?vue&type=script&lang=js"
export * from "./addCertSt.vue?vue&type=script&lang=js"
import style0 from "./addCertSt.vue?vue&type=style&index=0&id=4f8ca364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8ca364",
  null
  
)

export default component.exports